<template>
  <aside class="sidebar">
    <div class="sidebar-brand">
      <img src="/logo.png" alt="INVOXIS" class="brand-logo" />
    </div>

    <div class="sidebar-section">Property Management</div>

    <router-link to="/dashboard" class="nav-item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/>
      </svg>
      Dashboard
    </router-link>

    <router-link to="/reservations" class="nav-item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <path d="M8 4v16M2 9h20"/>
      </svg>
      Reservations
    </router-link>

    <router-link to="/properties" class="nav-item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      </svg>
      Properties
    </router-link>

    <div class="sidebar-section">Finance</div>

    <router-link to="/finance/month-end" class="nav-item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <line x1="2" y1="10" x2="22" y2="10"/>
      </svg>
      Month-end
    </router-link>

    <router-link to="/finance/xero-settings" class="nav-item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
      Finance sync
    </router-link>

    <div class="sidebar-section">Account</div>

    <router-link to="/settings" class="nav-item">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/>
      </svg>
      Settings
    </router-link>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600;700&display=swap');

.sidebar {
  width: 218px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #5b58d4 0%, #4e4bbb 30%, #6b4fd8 70%, #7b52c8 100%);
  display: flex;
  flex-direction: column;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
}

.sidebar-brand {
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-bottom: 1px solid #ebe9f8;
  flex-shrink: 0;
}

.brand-logo {
  height: 15px;
  width: auto;
  object-fit: contain;
}

.sidebar-section {
  padding: 20px 12px 4px;
  font-size: 0.58rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: rgba(255,255,255,0.4);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  margin: 1px 8px;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 500;
  color: rgba(255,255,255,0.55);
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  position: relative;
  background: none;
  border: none;
  width: calc(100% - 16px);
  text-align: left;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.nav-item:hover {
  background: rgba(255,255,255,0.09);
  color: rgba(255,255,255,0.9);
}

.nav-item.router-link-active {
  background: rgba(255,255,255,0.1);
  color: #fff;
  font-weight: 600;
}

.nav-item svg {
  opacity: 0.6;
  flex-shrink: 0;
  width: 15px;
  height: 15px;
}

.nav-item.router-link-active svg {
  opacity: 1;
}

.nav-badge {
  margin-left: auto;
  font-size: 0.55rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 100px;
}

.nav-badge.upgrade {
  background: #c8a84b;
  color: #fff;
}

.nav-locked {
  opacity: 0.35;
}
</style>
